import { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import ProtectedRoute from "../components/shared/ProtectedRoute";
import RoleProtectedRoute from "../components/shared/RoleProtectedRoute";
import { ROLES } from "../constants/roles";

// Lazy load service provider-specific components
const ServiceProviderDashboard = lazy(() => import("../pages/ServiceProvider/ServiceProviderDashboard"));
const ServiceProviderServices = lazy(() => import("../pages/ServiceProvider/ServiceProviderServices"));
const ServiceProviderRequests = lazy(() => import("../pages/ServiceProvider/ServiceProviderRequests"));
const ServiceProviderRequestDetail = lazy(() => import("../pages/ServiceProvider/ServiceProviderRequestDetail"));
const ServiceProviderNotifications = lazy(() => import("../pages/ServiceProvider/ServiceProviderNotifications"));

// Import existing components that service providers can access
const InstallationAndServicesList = lazy(() => import("../pages/InstalllationAndServices/ServicesList"));
const RequestedServices = lazy(() => import("../pages/InstalllationAndServices/RequestedServices"));
const RequestedServiceDetail = lazy(() => import("../pages/InstalllationAndServices/RequestedServiceDetail"));
const Notifications = lazy(() => import("../pages/Notifications"));

/**
 * Service Provider Routes Configuration
 * Defines all routes accessible to service provider role users
 */
export default function ServiceProviderRoutes() {
  return (
    <Routes>
      {/* Service Provider Dashboard */}
      <Route
        path="/dashboard"
        element={
          <RoleProtectedRoute requiredRole={ROLES.SERVICE}>
            <ServiceProviderDashboard />
          </RoleProtectedRoute>
        }
      />

      {/* Service Management Routes */}
      <Route
        path="/services"
        element={
          <ProtectedRoute permission="view_service">
            <ServiceProviderServices />
          </ProtectedRoute>
        }
      />

      {/* Service Request Routes */}
      <Route
        path="/requests"
        element={
          <ProtectedRoute permission="view_request_services">
            <ServiceProviderRequests />
          </ProtectedRoute>
        }
      />
      
      <Route
        path="/requests/:id"
        element={
          <ProtectedRoute permission="view_request_services">
            <ServiceProviderRequestDetail />
          </ProtectedRoute>
        }
      />

      {/* Notifications */}
      <Route
        path="/notifications"
        element={
          <ProtectedRoute permission="view_notification">
            <ServiceProviderNotifications />
          </ProtectedRoute>
        }
      />

      {/* Redirect any unknown routes to service provider dashboard */}
      <Route
        path="*"
        element={
          <RoleProtectedRoute requiredRole={ROLES.SERVICE}>
            <ServiceProviderDashboard />
          </RoleProtectedRoute>
        }
      />
    </Routes>
  );
}
